import { render } from "./pos2.vue?vue&type=template&id=2a834f55&scoped=true"
import script from "./pos2.vue?vue&type=script&lang=js"
export * from "./pos2.vue?vue&type=script&lang=js"

import "./pos2.vue?vue&type=style&index=0&id=2a834f55&scoped=true&lang=css"

import exportComponent from "/Users/arthaskyline/Documents/FILE_DELFIN/kodingan-arthaskyline/level-up/levelup-github/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a834f55"]])

export default __exports__